import { createApi } from '@reduxjs/toolkit/query/react'
import { FUNDING_SOURCE_ADD, FUNDING_SOURCE_DELETE, FUNDING_SOURCE_DETAILS, FUNDING_SOURCE_EDIT, FUNDING_SOURCE_LIST } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const fundingSourceApi = createApi({
    reducerPath: 'fundingSourceApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/funding-source",
    }),
    tagTypes: ["FundingSourceList", "FundingSourceDetails"],
    endpoints: (builder) => ({

        // get funding source list
        fundingSourceList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: FUNDING_SOURCE_LIST,
                data: { search, status, page, limit, sort }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["FundingSourceList"]
        }),

        // delete funding source
        deleteFundingSource: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${FUNDING_SOURCE_DELETE}/${id}`
            }),
            invalidatesTags: ["FundingSourceList", "FundingSourceDetails"]
        }),

        // create funding source
        createFundingSource: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: FUNDING_SOURCE_ADD,
                data
            }),
            invalidatesTags: ["FundingSourceList"]
        }),

        // funding source details
        fundingSourceDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${FUNDING_SOURCE_DETAILS}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["FundingSourceDetails"]
        }),

        // update private client
        updateFundingSource: builder.mutation({
            query: ({ data, fundingSourceId }) => ({
                method: "PUT",
                url: `${FUNDING_SOURCE_EDIT}/${fundingSourceId}`,
                data
            }),
            invalidatesTags: ["FundingSourceList", "FundingSourceDetails"]
        })
    })
})

export const {
    useFundingSourceListQuery,
    useDeleteFundingSourceMutation,
    useCreateFundingSourceMutation,
    useFundingSourceDetailsQuery,
    useUpdateFundingSourceMutation

} = fundingSourceApi;